import React from "react";
import { useT } from "../i18n";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTitle,
  DrawerDescription,
} from "./ui/drawer";
import { Globe, Check } from "lucide-react";

/**
 * LanguagePickerDrawer — modal shown on first launch (no stored choice) and
 * also reachable from Settings to switch language.
 */
export default function LanguagePickerDrawer({ open, onOpenChange, forced }) {
  const { lang, choose: chooseLang, t } = useT();

  const choose = (l) => {
    chooseLang(l); // sets lang AND clears needsChoice in i18n context
    onOpenChange?.(false);
  };

  const opts = [
    { code: "it", flag: "🇮🇹", name: t("lang.italian"), sample: "Latte fresco · 28/04/2026" },
    { code: "en", flag: "🇺🇸", name: t("lang.english"), sample: "Whole milk · 04/28/2026" },
  ];

  return (
    <Drawer
      open={open}
      onOpenChange={(o) => { if (!forced || !o) return; onOpenChange?.(o); }}
      modal
      dismissible={!forced}
    >
      <DrawerContent data-testid="lang-picker">
        <div className="mx-auto w-full max-w-lg text-zinc-950">
          <DrawerHeader className="text-left">
            <div className="w-12 h-12 rounded-2xl bg-zinc-950 text-white flex items-center justify-center mb-3">
              <Globe className="w-5 h-5" />
            </div>
            <DrawerTitle className="font-heading text-2xl font-medium">{t("lang.title")}</DrawerTitle>
            <DrawerDescription>{t("lang.subtitle")}</DrawerDescription>
          </DrawerHeader>
          <div className="px-4 pb-6 space-y-3">
            {opts.map((o) => {
              const active = lang === o.code;
              return (
                <button
                  key={o.code}
                  onClick={() => choose(o.code)}
                  className={`w-full rounded-2xl border p-4 flex items-center gap-4 text-left transition active:scale-[0.99] ${
                    active ? "border-zinc-950 bg-zinc-950 text-white" : "border-zinc-200 bg-white text-zinc-950"
                  }`}
                  data-testid={`lang-pick-${o.code}`}
                >
                  <div className={`w-12 h-12 rounded-xl flex items-center justify-center text-2xl ${active ? "bg-white/10" : "bg-zinc-100"}`}>
                    {o.flag}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-heading text-lg font-medium">{o.name}</div>
                    <div className={`text-xs mt-0.5 font-mono ${active ? "text-white/60" : "text-zinc-500"}`}>{o.sample}</div>
                  </div>
                  {active && <Check className="w-5 h-5" strokeWidth={3} />}
                </button>
              );
            })}
            <p className="text-[11px] text-zinc-500 text-center pt-2">
              {t("settings.lang.desc")}
            </p>
          </div>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
